module.exports = __webpack_public_path__ + "static/media/sykkeltur.0f54c0ea.jpg";